import React from "react";
import PropTypes from "prop-types";

import {
	Toolbar as RhombusToolbar
} from "rhombus-react";

import { SEARCH_DEBOUNCE } from "utils/constants";
import AddContentFeedButton from "./AddContentFeedButton";

import "./Toolbar.css";

export default function Toolbar({ searchTerm = "", handleSearch }) {
	return (
		<RhombusToolbar
			className="content-feed-toolbar"
			search
			searchDebounce={SEARCH_DEBOUNCE}
			onSearch={handleSearch}
			searchValue={searchTerm}
		>
			<div className="button-side">
				<AddContentFeedButton />
			</div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "ContentFeedsToolbar";

Toolbar.propTypes = {
	searchTerm: PropTypes.string,
	handleSearch: PropTypes.func.isRequired,
};
